import { COLORS } from 'helpers/globals'

const button = {
  color: 'white',
  borderRadius: 10,
  padding: '.75rem 1.5rem',
  width: '75%',
  margin: 'auto',
  border: `1px solid ${COLORS.secondary}`
}

export default {
  appContainer: {
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-start !important'
  },
  startBody: {
    background: 'rgba(0, 0, 0, 0.5)',
    flex: 1,
    display: 'flex',
    minHeight: 0
  },
  topBar: {
    display: 'flex',
    padding: '.5rem 1rem'
  },
  backLink: {
    flex: 1,
    color: 'black',
    fontWeight: '600'
  },
  backButton: {
    marginRight: '.5rem',
    fontSize: '1.4rem',
    verticalAlign: '-.1rem'
  },
  logo: {
    height: '2rem',
    margin: 'auto'
  },
  dialog: {
    width: '90%',
    maxWidth: '400px',
    margin: 'auto',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid black',
    background: 'white',
    fontSize: '2rem',
    fontWeight: '500',
    paddingBottom: '1.5rem'
  },
  header: {
    background: COLORS.primary,
    color: 'white',
    borderBottom: '1px solid black',
    marginBottom: '1.5rem'
  },
  greenButton: {
    ...button,
    background: '#009e25'
  },
  disabled: {
    opacity: '0.5'
  },
  blueButton: {
    ...button,
    background: COLORS.primary,
    marginTop: '2rem'
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1rem',
    fontSize: '1.6rem'
  },
  loadingIcon: {
    margin: 'auto auto 1rem auto',
    fontSize: '4.5rem'
  },
  locationButton: {
    marginRight: '.5rem',
    fontSize: '1.7rem'
  },
  mapButton: {
    marginRight: '.5rem',
    fontSize: '1.7rem'
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    fontSize: '3rem',
    color: 'white',
    fontWeight: '400',
    display: 'flex',
    flexDirection: 'column'
  },
  loadingButton: {
    margin: 'auto auto 1rem auto',
    fontSize: '4rem'
  },
  loginContainer: {
    width: '90%',
    maxWidth: '600px',
    background: 'white',
    margin: 'auto'
  },
  loginHeader: {
    padding: '1rem',
    background: COLORS.primary,
    color: 'white'
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileStart/style.js